/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createDraftPreviewSession} from '../api'

export const useMutationCreateDraftPreviewSession = createReactQueryMutationHook('createDraftPreviewSession', createDraftPreviewSession)
